import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { NameFieldsComponent } from './name-fields/name-fields.component';
import { PasswordFieldsComponent } from './password-fields/password-fields.component';
import { EmailFieldComponent } from './email-field/email-field.component';
import { PhoneFieldComponent } from './phone-field/phone-field.component';
import { GenderFieldComponent } from './gender-field/gender-field.component';
import { BirthdateFieldComponent } from './birthdate-field/birthdate-field.component';
import { AddressFieldsComponent } from './address-fields/address-fields.component';
import { ProgressiveAddressFieldsComponent } from './progressive-address-fields/progressive-address-fields.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    IonicModule,
    TranslateModule,
    // Import all standalone components
    NameFieldsComponent,
    PasswordFieldsComponent,
    EmailFieldComponent,
    PhoneFieldComponent,
    GenderFieldComponent,
    BirthdateFieldComponent,
    AddressFieldsComponent,
    ProgressiveAddressFieldsComponent
  ],
  exports: [
    // Export all components for use in other modules
    NameFieldsComponent,
    PasswordFieldsComponent,
    EmailFieldComponent,
    PhoneFieldComponent,
    GenderFieldComponent,
    BirthdateFieldComponent,
    AddressFieldsComponent,
    ProgressiveAddressFieldsComponent
  ]
})
export class FormComponentsModule { } 